import { useCallback, useMemo } from "react"
import { useDeleteConfirm } from "../../../../hooks/useDeleteConfirm"
import { useFeedbackTopics } from "../../../../hooks/useFeedbackTopics"
import { DimaFeatureShortNameEnum } from "../../../models/Authorization"
import { FeedbackTopicGet } from "../../../models/FeedbackTopic"
import { deleteEntity } from "../../../utils/deleteEntity"
import { DiMaAddButton } from "../../partials/DiMaAddButton"
import { EntityRow, EntityTab } from "../../partials/EntityTab"

export function FeedbackTopics() {
  const { feedbackTopicsList, isLoadingFeedbackTopics } = useFeedbackTopics()
  const { requestDelete, DeleteConfirmDialog } = useDeleteConfirm()

  const cols = [
    {
      field: "name",
      headerName: "Name",
      isLink: true,
      linkBasePath: "/feedbacks/topics",
    },
    { field: "applicationName", headerName: "App" },
    { field: "priority", headerName: "Priority" },
  ]

  const sorted = [...feedbackTopicsList].sort(
    (a, b) => (a.priority ?? 0) - (b.priority ?? 0)
  )

  const rows = sorted.map((feedbackTopic: FeedbackTopicGet) => ({
    id: feedbackTopic.id,
    name: feedbackTopic.name,
    applicationName: feedbackTopic.application.name,
    priority: feedbackTopic.priority,
  }))

  const toolbar = useMemo(
    () => (
      <DiMaAddButton
        url="/feedbacks/topics/create"
        feature={DimaFeatureShortNameEnum.FB}
      />
    ),
    []
  )

  const handleActionMenuClick = useCallback(
    (item: { title: string }, row: EntityRow) => {
      if (item.title === "Delete") {
        requestDelete(() => deleteEntity(`/feedbackTopics/${row.id}`))
      }
    },
    [requestDelete]
  )

  return (
    <>
      {DeleteConfirmDialog}
      <EntityTab
        rows={rows}
        cols={cols}
        isLoading={isLoadingFeedbackTopics}
        toolbar={toolbar}
        actionItems={[{ title: "Delete", iconName: "icon_abb_dias icon-abb_delete" }]}
        onActionMenuClick={handleActionMenuClick}
      />
    </>
  )
}
